import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api/client.js';
import { useT } from '../i18n/LangContext.jsx';
import T from '../i18n/content.js';
import ArticleView from '../components/ArticleView.jsx';

export default function InsightDetailPage() {
  const { id } = useParams();
  const t = useT();
  const navigate = useNavigate();
  const [insight, setInsight] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.insight(id).then(data => {
      setInsight(data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return (
      <section className="section" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ fontFamily: 'var(--label)', fontSize: 12, letterSpacing: '.3em', color: 'var(--bronze)' }}>Loading…</p>
      </section>
    );
  }

  if (!insight) {
    return (
      <section className="section" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 24 }}>
        <p style={{ fontFamily: 'var(--display)', fontSize: 28, color: 'var(--slate-70)' }}>Article not found</p>
        <button className="btn-ghost" onClick={() => navigate('/insights')}>{t(T.common.backToHome)}</button>
      </section>
    );
  }

  return <ArticleView item={insight} backTo="/insights" />;
}
